import { Directive } from '@angular/core';

@Directive({
    selector: '[qpxPillLabel]',
    host: {
        class: 'qpx-pill__label',
    },
})
export class QpxPillLabel {}
